export const E_LEARNING_LIST_URL =
  "/e-learning-creator/step/published-dashboard-list";
export const COURSES_LIST_URL = "/e-learning-course-user/list";
export const SHOW_NEXT_PILL_URL = "/e-learning-course-user/show-next-pill";
export const CHECK_COURSE_COMPLETED =
  "/e-learning-course-user/check-course-completed";
export const GET_PLAYER_STATISTIC_DATA_URL =
  "/e-learning-course-user/get-statistic-data";

export const SET_E_LEARNING_LIST_ACTION = "SET_E_LEARNING_LIST_ACTION";
export const E_LEARNING_USER_DATA_URL = "/user/goal/user-profile-data";

export const SAVE_EVENT_PAGE = "/user/event/save";
export const SAVE_ANON_EVENT_PAGE = "/anon/save-event";
